import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { UserService } from './user.service';

/**
 * Runs on /login. A user who is still signed in (closed the tab and came back,
 * or typed the root URL) goes straight to their role's landing page instead of
 * the login form.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuardService {

  constructor(private _userService: UserService, private _router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot): boolean | UrlTree {
    // a ?token= link signs in as another user, the login page handles it
    if (next.queryParamMap.has('token')) {
      return true;
    }
    // schoolId is written last in the login flow, so a half-finished login still shows the form
    if (!localStorage.getItem('token') || !localStorage.getItem('schoolId')) {
      return true;
    }
    if (!this._userService.isAuthenticated()) {
      return true;
    }
    return this._router.parseUrl(this._userService.getHomeUrl());
  }
}
